
import { JSEncrypt } from 'jsencrypt'
import { getLoginPublicKey } from './api'
import { useNavigate } from 'react-router-dom'

/** 对密码加密 */
export async function encryptPsw (psw: string, publicKey?: string) {
  // 创建JSEncrypt对象
  const encrypt = new JSEncrypt()
  let key = publicKey
  // 设置公钥
  if (!key) {
    key = await getLoginPublicKey()
  }
  encrypt.setPublicKey(key)
  // 加密数据
  return encrypt.encrypt(psw) || ''
}

export const getLoginPath = () => `/login?backpath=${encodeURIComponent(window.location.hash.slice(1))}`

/** 跳转登录页 */
export const useJumpLogin = () => {
  const navigate = useNavigate()
  return () => navigate(getLoginPath(), { replace: true })
}

/** 登录页 */
